export default __webpack_public_path__ + "static/media/wrong1.534b021c.png";